import {createContext, useContext, useReducer} from "react";
import * as Icons from "./icons";
import * as Iconly from "react-iconly";
const SidebarContext = createContext(null);

export const types = {
    "SET_SELECTED": "SET_SELECTED",
    "SET_CLOSED": "SET_CLOSED",
}

const initializeState = {
    items:[
        // {
        //     id: 1,
        //     icon:(active)=>{return <span className={`flex align-items-center p-1 border-round ${active && "bg-primary"}`}><Iconly.Home active={active} primaryColor={ active && "white"} filled={active} size="medium" /></span>},
        //     title: "home",
        //     path:"/"
        // },
        {
            id: 1,
            icon:(active)=>{return <span className={`flex align-items-center border-round ${active && "bg-primary"}`}><Icons.Ticket active={active} primaryColor={ active && "white"} filled={active} size="medium" /></span>},
            title: "support",
            path:"/case"
        },
        {
            id: 2,
            icon:(active)=>{return <span className={`flex align-items-center border-round ${active && "bg-primary"}`}><Icons.Ticket active={active} primaryColor={ active && "white"} filled={active} size="medium" /></span>},
            title: "invoices",
            path:"/invoices"
        }
    ],
    selectedItem: 1,
    isClosed: false,
}

const reducer = (state, action)=>{
    switch (action.type){
        case types.SET_CLOSED:
            state = {...state, isClosed:action.isClosed}
            break;
        case types.SET_SELECTED:
            state = {...state, selectedItem:action.selectedItem}
            break;
        default : throw Error(`An unknown Action to Sidebar Reducer ${action.type}`)
    }
    // console.log(state);
    return state;
}

const SidebarProvider = ({children})=>{
    let [state, dispatch] = useReducer(reducer, initializeState);

    return(
        <SidebarContext.Provider value={{state, dispatch}}>
            {children}
        </SidebarContext.Provider>
    )
}

const useSidebar = () => {
    let context = useContext(SidebarContext);
    if (!context){
        throw Error("useSidebar should be used inside SidebarProvider");
    }
    let {state, dispatch} = context;

    const getSelectedItem = ()=>{
        return state.items.find(item=>item.id===state.selectedItem)
    }

    return{state, dispatch, getSelectedItem};
}

export {SidebarProvider, useSidebar}